import { render } from "./CompleteEvent.vue?vue&type=template&id=4a50c5ea&scoped=true"
import script from "./CompleteEvent.vue?vue&type=script&lang=js"
export * from "./CompleteEvent.vue?vue&type=script&lang=js"

import "./CompleteEvent.vue?vue&type=style&index=0&id=4a50c5ea&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a50c5ea"]])

export default __exports__